import api from './api';

class TimeMaterialsService {
  static async getTimeMaterials(contractId) {
    const response = await api.get(`/contracts/${contractId}/time-materials`);
    return response.data;
  }

  static async createTimeMaterials(contractId, payload) {
    const response = await api.post(`/contracts/${contractId}/time-materials`, payload);
    return response.data;
  }

  static async updateTimeMaterials(contractId, id, payload) {
    const response = await api.put(`/contracts/${contractId}/time-materials/${id}`, payload);
    return response.data;
  }

  static async deleteTimeMaterials(contractId, id) {
    const response = await api.delete(`/contracts/${contractId}/time-materials/${id}`);
    return response.data;
  }
}

export default TimeMaterialsService;
